﻿import Glide from '@glidejs/glide';

// This file contains global configuration that should be called on every page load.
document.addEventListener('alpine:init', () => {
  // Footer
  Alpine.data('footerData', () => ({
    expanded: false,
    init() {
      this.$watch('expanded', (value) => {
        if (value) {
          setTimeout(() => this.scrollToBottom(), 500);
        }
      });
    },
    scrollToBottom() {
      window.scrollTo({
        left: 0,
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    },
  }));

  // Header
  Alpine.data('navData', () => ({
    showMenu: false,
    active: null,
    main: null,
    init() {
      this.main = document.querySelector('main');
    },
    openMenu() {
      this.showMenu = true;
      this.main.classList.add('hidden');
    },
    closeMenu() {
      this.showMenu = false;
      this.main.classList.remove('hidden');
    },
  }));

  // Statistics
  Alpine.data('counterAnimation', (target, duration = 3000) => ({
    visible: false,
    target: target,
    duration: duration,
    hasAnimated: false,

    init() {
      // Use native Intersection Observer instead of Alpine's @intersect
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.startAnimation();
            observer.unobserve(entry.target); // Stop observing after first trigger
          }
        });
      }, { threshold: 0.1 }); // Trigger when 10% of element is visible

      // Observe the root element
      observer.observe(this.$el);
    },

    startAnimation() {
      if (!this.hasAnimated) {
        this.hasAnimated = true;
        this.visible = true;
        this.animateCounter();
      }
    },

    animateCounter() {

      const counter = this.$refs.counter;
      let startTime = 0;

      const animate = (timestamp) => {
        if (startTime === 0) {
          startTime = timestamp;
        }

        const progress = timestamp - startTime;
        const percentage = Math.min(progress / this.duration, 1);
        const value = Math.floor(percentage * this.target);

        // Use toLocaleString for number formatting
        counter.innerHTML = value.toLocaleString();

        if (percentage !== 1) {
          window.requestAnimationFrame(animate);
        }
      };

      window.requestAnimationFrame(animate);
    },
  }));

  // CTA Banner visibility for Job Posting
  Alpine.data('ctaBannerData', () => ({
    showCTABanner: false,
    observerButton: null,

    init() {
      // Wait for next tick to ensure refs are available
      this.$nextTick(() => {
        if (this.$refs.ctaButton) {
          // Use native Intersection Observer instead of Alpine's @intersect
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              // Show banner when element leaves viewport (not intersecting)
              // Hide banner when element enters viewport (intersecting)
              this.showCTABanner = !entry.isIntersecting;
            });
          }, { threshold: 0 }); // Trigger as soon as any part enters/leaves

          // Observe the CTA button
          observer.observe(this.$refs.ctaButton);
        }
      });
    },
  }));
});

if (document.querySelectorAll('.glide') !== null) {
  var sliders = document.querySelectorAll('.glide');

  for (var i = 0; i < sliders.length; i++) {
    var glide = new Glide(sliders[i], {
      type: 'carousel',
      perView: 3,
      breakpoints: {
        500: {
          perView: 1,
        },
        900: {
          perView: 2,
        },
      },
      focusAt: 'center',
      autoplay: 2000,
    });

    glide.mount();
  }
}

if (document.querySelectorAll('.glideGroupSlider') !== null) {
  var sliders = document.querySelectorAll('.glideGroupSlider');

  for (var i = 0; i < sliders.length; i++) {
    var glide = new Glide(sliders[i], {
      type: 'slider',
      perView: 1,
      startAt: 0,
      focusAt: 'center',
      rewind: false,
    });

    glide.mount();
  }
}

// Remember the language picked with the NL/FR switch, so a later visit to a URL without
// a /nl or /fr prefix lands in that language instead of falling back to browser
// detection. Read by the language rules in web.config.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) {
    return;
  }

  const trigger = event.target.closest('[data-language-switch]');
  if (!trigger) {
    return;
  }

  const language = trigger.getAttribute('data-language-switch');
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  document.cookie = 'proman_lang=' + language + '; path=/; max-age=31536000; samesite=lax' + secure;
});

// Companion to the redirect in _Layout. That one acts on a stored choice; this one only has
// a hint (a French browser on a Dutch page), so it suggests rather than forces. global.js is
// deferred, so the document is parsed by the time this runs.
(() => {
  const banner = document.querySelector('[data-language-suggestion]');
  if (!banner) {
    return;
  }

  // An explicit choice, in either direction, means we stop guessing.
  const hasStoredChoice = /(^|;\s*)proman_lang=/i.test(document.cookie);
  const browserIsFrench = /^fr(-|_|$)/i.test(navigator.language || '');

  if (!/^\/nl(\/|$)/i.test(window.location.pathname) || hasStoredChoice || !browserIsFrench) {
    return;
  }

  const alternate = document.querySelector('link[rel="alternate"][hreflang^="fr" i]');
  if (!alternate) {
    return;
  }

  const target = new URL(alternate.href, window.location.href);
  if (target.origin !== window.location.origin || !/^\/fr(\/|$)/i.test(target.pathname)) {
    return;
  }

  // Keep utm/pubid parameters, otherwise the switch breaks campaign attribution.
  if (window.location.search) {
    target.search = window.location.search;
  }
  if (window.location.hash) {
    target.hash = window.location.hash;
  }

  banner.querySelector('[data-language-suggestion-link]').href = target.href;

  // The cookie itself is stored by the data-language-switch handler above.
  banner.querySelector('[data-language-suggestion-dismiss]').addEventListener('click', () => {
    banner.hidden = true;
  });

  banner.hidden = false;
})();
